<template>
	<div class="equipmentInstallationManagement ">

		<div class="itemTitleBox disBetween">
			<div class="disStart">
				<span class="title">设备列表</span>
			</div>
			<!-- <div class="icon_add iconBox" @click="openDia(5)" title="新建设备"></div> -->
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disBetween searchLeft">
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityEquipmentNo" placeholder="请输入设备编号"></el-input>
					</div>
					<div class="myinputBox">
						<!-- <el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input> -->
						<el-select clearable v-model="searchObj.communityId" allow-create filterable remote
							reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
							<el-option v-for="item in restaurants" :key="item.communityId" :label="item.communityName"
								:value="item.communityId">
							</el-option>
						</el-select>
					</div>
					<div class="myinputBox">
						<el-select clearable v-model="searchObj.equipmentStatus" slot="prepend" placeholder="请选择设备状态">
							<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox">
						<el-select clearable v-model="searchObj.equipmentRunStatus" slot="prepend"
							placeholder="请选择运营状态">
							<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox">
						<el-select clearable v-model="searchObj.count" slot="prepend" placeholder="请选择充电次数排序">
							<el-option v-for="(item,inx) in countList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
				</div>
				<div>
					<el-button type="success" @click="exportData">导出</el-button>
					<el-button type="success" @click="exportDatas">导出现有设备</el-button>
				</div>
				
			</div>
		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号" width="100">
						</el-table-column>

						<el-table-column show-overflow-tooltip prop="communitySiteName" label="设备位置">
							<template slot-scope="scope">
								<span v-if="scope.row.communityName">{{scope.row.communityName}}-</span>
								<span>{{scope.row.communitySiteName}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="使用率(日)">
							<template slot-scope="scope">
								<div class="clickUndline" @click="showPower(scope.row)">
									<span class="green"
										v-if=" scope.row.dayUseCount>=5 ">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									<span class="orange"
										v-if="scope.row.dayUseCount>=3 && scope.row.dayUseCount<5">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									<span class="red"
										v-if="scope.row.dayUseCount<3">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="dayUseCount" label="充电次(日)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="monthUserCount" label="充电次(月)">
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="yearUseCount" label="充电次(年)" width="120">
							</el-table-column> -->
						<el-table-column prop="equipmentStatus" label="状态" width="160">
							<template slot-scope="scope">
								<span v-if="scope.row.equipmentInstallStatus==1">未安装</span>
								<span v-else>{{getName(scope.row.equipmentStatus,equStatusList)}}
									<span
										v-if="scope.row.equipmentStatus==2 && scope.row.unlineFlag">({{getName(scope.row.unlineFlag,unlineFlagList)}})</span>
								</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="unlineCount" label="离线次数" width="120">
							<template slot-scope="scope">
								<div class="clickUndline" @click="showUnlineCount(scope.row)">
									{{scope.row.unlineCount}}
								</div>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentJackNumber" label="插座" width="80">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="version" label="版本号" width="80">
						</el-table-column>
						<!-- <el-table-column show-overflow-tooltip prop="equipmentServiceProvider" label="运营商" width="100">
							</el-table-column> -->

						<!-- <el-table-column prop="equipmentRunStatus" label="运营状态" width="120">
								<template slot-scope="scope">
									<span>{{getName(scope.row.equipmentRunStatus,operateStatusList)}}</span>
								</template>
							</el-table-column> -->
						<el-table-column prop="operate" label="操作" width="50" fixed="right">
							<template slot-scope="scope">
								<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
									<div class="pupBox">
										<span class="hoverClass" @click.stop="itemClick(scope.row,3)">二维码</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,9)">功率配置</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,6)">充电记录</span>
										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,5)"
												>解绑</span> -->
										<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,2)">运维记录</span> -->
										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,4)">删除</span> -->

										<!-- <span class="hoverClass" @click.stop="itemClick(scope.row,7)">复位</span> -->
									</div>
									<div slot="reference" class="itemRight listIcon"></div>
								</el-popover>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="75%">
			<div class="disBetween diaBtnBox">
				<span class="" title="解绑" v-if="creatObj.communityId" @click.stop="itemClick(creatObj,5)">解绑</span>
				<span class="" title="复位" @click.stop="itemClick(creatObj,7)">复位</span>
			</div>
			<el-form :model="creatObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备编号">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communityEquipmentNo" placeholder="请输入设备编号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="所属社区">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communityName" placeholder="请输入社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">

						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营状态" prop="equipmentRunStatus">
								<div class="myinputBox">
									<el-select clearable :disabled="dialogVisible" v-model="creatObj.equipmentRunStatus"
										slot="prepend" placeholder="请选择运营状态">
										<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="IP地址" prop="communityEquipmentIp">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisible"
										v-model="creatObj.communityEquipmentIp" placeholder="请输入IP地址">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最小功率">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisible" v-model="creatObj.equipmentMinPower"
										placeholder="">
										<template slot="append">W</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大功率">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisible" v-model="creatObj.equipmentMaxPower"
										placeholder="">
										<template slot="append">W</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">

						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="插座规格" prop="equipmentJackNumber">
								<div class="myinputBox">
									<el-input clearable :disabled="dialogVisible" v-model="creatObj.equipmentJackNumber"
										placeholder="请输入插座规格">
										<template slot="append">路</template>
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装日期">
								<div class="myinputBox">
									<el-date-picker disabled value-format="yyyy-MM-dd"
										v-model="creatObj.equipmentInstallTime" type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="运营商" prop="equipmentServiceName">
								<div class="myinputBox">
									<el-autocomplete clearable class="inline-input"
										v-model="creatObj.equipmentServiceName" :fetch-suggestions="querySearch"
										placeholder="请输入运营商名称" @select="handleSelect">
									</el-autocomplete>
								</div>
							</el-form-item>
						</div>
					</div> -->
					<div class="diaItem disBetween">

						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="安装状态" prop="equipmentInstallStatus">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.equipmentInstallStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equipmentInstallStatusList" :key="inx"
											:label="item.text" :value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备状态" prop="equipmentInstallStatus">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.equipmentStatus" slot="prepend"
										placeholder="请选择安装状态">
										<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-if="creatObj.equipmentStatus==2">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线时间" prop="unlineTime">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="离线理由">
								<div class="myinputBox">
									<el-select disabled v-model="creatObj.unlineFlag" slot="prepend" placeholder="">
										<el-option v-for="(item,inx) in unlineFlagList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween" v-else>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="上次离线时间" prop="unlineTime">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.unlineTime" placeholder="">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="设备位置" prop="communitySiteName">
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.communitySiteName" placeholder="请输入设备位置">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem" v-if="creatObj.equipmentStatus==1">
						<div class="diaTpye disStart">
							插座状态
						</div>
						<div class="czBox disStart">
							<div class="czItem disStart" v-for="(item,inx) in creatObj.equipmentPortList" :key="inx">
								<div class="disStart">
									<span>插座{{item.communityEquipmentPort}}：</span>
									<span
										:class="item.portStatus==1?'blue':item.portStatus==2?'green':item.portStatus==3?'red':''">{{item.portStatus==1?"空闲":item.portStatus==2?"使用中":item.portStatus==3?"故障":""}}</span>
									<span class="czIcon" title="复位" @click="itemClick(item,8)"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter" v-if="dialogVisible">
					<!-- <el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm3')">保 存</el-button> -->
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="创建设备二维码数量" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备数量" prop="initializeEquipmentNum">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.initializeEquipmentNum,200)"
										v-model="creatObj.initializeEquipmentNum" type="Number"
										placeholder="请输入设备数量"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="插座规格" prop="equipmentJackNumber">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.equipmentJackNumber" placeholder="请选择插座规格"
										:remote-method="remoteMethod">
										<el-option v-for="item in luList" :key="item.paramConfigItemId"
											:label="item.paramConfigItemName" :value="item.paramConfigItemName">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备前缀" prop="prefix">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.prefix" placeholder="请选择设备前缀"
										:remote-method="remoteMethod">
										<el-option v-for="item in prefixList" :key="item.paramConfigItemName"
											:label="item.paramConfigItemName" :value="item.paramConfigItemName">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :title="device" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="equipmentCard"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="cardBox disCenter">
					<img :src="cardUrl" alt="" sizes="" srcset="">
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="echartsTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="showPowerEcharts" width="90%">
			<div class="dialogBox1">
				<div class="disStart">
					<div class="diaItem ">
						<div class="timeType disStart">
							<span class="disCenter" :class="{active:active==1}" @click="active=1">月</span>
							<span class="disCenter" :class="{active:active==2}" @click="active=2">年</span>
						</div>
						<div class="myinputBox myinputBox2">
							<el-date-picker v-show="active==1" :clearable="NOfalse" :editable="NOfalse"
								v-model="searchMonth" value-format="yyyy-MM" type="month" placeholder="选择日期">
							</el-date-picker>
							<el-date-picker v-show="active==2" :clearable="NOfalse" :editable="NOfalse"
								v-model="searchYear" value-format="yyyy" type="year" placeholder="选择日期">
							</el-date-picker>
						</div>
						<el-button type="success" @click="getEcharts">查询</el-button>
					</div>
				</div>
				<div v-loading="echartLoading" class="statisticalRight" id="myEcharts2"></div>
			</div>
		</el-dialog>
		<el-dialog title="离线记录" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation3"
			width="80%">
			<div class="dialogBox dialogBox3">
				<div class="myTable myTable2">
					<el-table :data="operationData" stripe style="width: 100%" height="500" v-loading="undeloading">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentId" label="设备ID">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="unlineTime" label="离线时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="unlineFlag" label="离线理由">
							<template slot-scope="scope">
								<span>{{getName(scope.row.unlineFlag,unlineFlagList)}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="充电功率(W)" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow1"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm5" label-width="100px" class="demo-ruleForm">
				<div class=" dialogBox5">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最小功率" prop="equipmentMinPower">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.equipmentMinPower,2000,1)"
										v-model="creatObj.equipmentMinPower" type="text" placeholder="请输入最低充电功率"
										oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
									<!-- <el-select clearable v-model="creatObj.equipmentMinPower" slot="prepend"
										placeholder="请选择最低输出功率">
										<el-option v-for="(item,inx) in minList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select> -->
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大功率" prop="equipmentMaxPower">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.equipmentMaxPower,2000,2)"
										v-model="creatObj.equipmentMaxPower" type="text" placeholder="请输入最低充电功率"
										oninput="value=value.replace(/[^\d]/g,'')">
										<template slot="append"></template></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow1=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm5')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "@/assets/js/common.js"
	export default {
		name: "accountManage",
		components: {},
		data() {
			var checkNum = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入设备二维码数量'));
				}
				setTimeout(() => {
					if (isNaN(parseFloat(value))) {
						callback(new Error('请输入数字值'));
					} else {
						callback();
					}
				}, 500);
			};
			return {
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				dialogOperation3: false,
				undeloading: false,
				visibleShow1: false,
				operationData: [],
				active: 1,
				searchMonth: "",
				searchYear: "",
				device: "设备二维码",
				creatObj: {},
				dialogVisible: false,
				visibleShow: false,
				showPowerEcharts: false,
				NOfalse: false,
				dialogTitle: "新建设备",
				echartsTitle: "设备使用率",
				stationList: [],
				equStatusList: [{
						text: "正常",
						value: 1
					},
					{
						text: "离线",
						value: 2
					},
					{
						text: "故障",
						value: 3
					},
				],
				equipmentInstallStatusList: [{
						text: "未安装",
						value: 1
					},
					{
						text: "已安装",
						value: 2
					},

				],
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				statusList: [{
						text: "使用中",
						value: 1
					},
					{
						text: "禁用",
						value: 2
					}
				],
				unlineFlagList: [{
						text: "设备自动断电",
						value: 1
					},
					{
						text: "检测不到心跳",
						value: 2
					}
				],
				countList: [{
						text: "月充电次数从低到高",
						value: 1
					},
					{
						text: "月充电次数从高到低",
						value: 2
					}
				],
				tableData: [],
				cardUrl: "",
				options: [],
				loading: false,
				echartLoading: false,
				equipmentCard: false,
				searchObj: {
					communityId: "", //社区编号
					communitySiteId: "",
					communityEquipmentNo: "",
					equipmentStatus: "",
					equipmentRunStatus: "",
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
				},
				restaurants: [],
				luList: [],
				prefixList: [],
				equipmentObj: {},
				rules: {
					// initializeEquipmentNum: [{
					// 		validator: checkNum,
					// 		trigger: 'blur'
					// 	},
					// 	{
					// 		required: true,
					// 		message: '请输入设备二维码数量',
					// 		trigger: 'blur'
					// 	}
					// ],
					// communitySiteName: [{
					// 	required: true,
					// 	message: '请输入设备位置',
					// 	trigger: 'change'
					// }],
					// equipmentJackNumber: [
					// 	{
					// 		required: true,
					// 		message: '请选择插座规格',
					// 		trigger: 'change'
					// 	}
					// ],
					// prefix: [
					// 	{
					// 		required: true,
					// 		message: '请选择设备前缀',
					// 		trigger: 'change'
					// 	}
					// ],
					equipmentMinPower: [{
						required: true,
						message: '请输入最低充电功率',
						trigger: 'blur'
					}],
					equipmentMaxPower: [{
						required: true,
						message: '请输入最大充电功率',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			this.selectParamConfigByCode()
			this.$set(this, "searchMonth", timestampToDate(new Date()).slice(0, 7))
			this.$set(this, "searchYear", timestampToDate(new Date()).slice(0, 4))
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			showUnlineCount(item) {
				this.$api.listUnlineRecord({
					communityEquipmentNo: item.communityEquipmentNo
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "operationData", res.obj)
						this.dialogOperation3 = true
					}
				})
				// undeloading:false
			},
			showPower(obj) {
				this.echartsTitle = "使用率曲线图（" + obj.communityEquipmentNo + "）"
				this.$set(this, "equipmentObj", obj)
				this.getEcharts()
			},
			getEcharts() {
				this.echartLoading = true
				let time = ""
				if (this.active == 1) {
					time = this.searchMonth
				} else {
					time = this.searchYear
				}
				let item = {
					xDate: [],
					data: []
				}
				this.showPowerEcharts = true
				this.$api.selectEquipmentUsedByEquipmentIdAndDateType({
					dateType: this.active,
					date: time,
					communityEquipmentId: this.equipmentObj.communityEquipmentId
				}).then((res) => {
					if (res.returnCode == 200) {
						this.echartLoading = false
						if (res.obj.usedList && res.obj.usedList.length > 0) {
							this.showPowerEcharts = true
							for (let k in res.obj.dateList) {
								if (this.active == 1) {
									this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "号")
								} else {
									this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "月")
								}
							}
							this.$set(item, "xDate", res.obj.dateList || [])
							this.$set(item, "data", res.obj.usedList || [])
							this.$nextTick(() => {
								this.showEchart(item)
							})
						}
					}
				})
			},
			showEchart(item) {
				let that = this
				let getchart = that.$echarts.init(document.getElementById('myEcharts2'));
				getchart.clear()
				var option = {
					tooltip: {
						trigger: "axis",
						valueFormatter: function(value) {
							return value + "%"
						}
					},
					grid: {
						top: "8%",
						left: "1%",
						right: "4%",
						bottom: "8%",
						containLabel: true,
					},
					xAxis: [{
						type: "category",
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},
						splitLine: {
							show: false,
						},

						splitArea: {
							show: false,
						},
						data: item.xDate,
					}, ],
					yAxis: [{
						name: "使用率：%",
						type: "value",
						min: that.min,
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},

					}, ],
					dataZoom: [{
							show: true,
							height: 30,
							xAxisIndex: [0],
							bottom: -60,
							start: 0,
							end: that.end,
						},
						{
							type: "inside",
							show: true,
							height: 15,
							start: 1,
							end: 50,
						},
					],
					series: [{
						name: "使用率",
						type: "line",
						smooth: true, //是否平滑曲线显示
						symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						symbolSize: 10,
						lineStyle: {
							normal: {
								color: "#03adac", // 线条颜色
							},
						},
						data: item.data,
					}, ],
				};

				getchart.setOption(option);
			},
			numberChange(val, maxNum, n) {
				if (n == 1) {
					//转换数字类型
					let num = Number(val)
					// if (num < 1) {
					// 	this.$set(this.creatObj, "equipmentMinPower", 1)
					// }
					if (num > 2000) {
						this.$set(this.creatObj, "equipmentMinPower", 2000)
					}
				} else if (n == 2) {
					//转换数字类型
					let num = Number(val)
					// if (num < 1) {
					// 	this.$set(this.creatObj, "equipmentMaxPower", 1)
					// }
					if (num > 2000) {
						this.$set(this.creatObj, "equipmentMaxPower", 2000)
					}
				} else {
					//转换数字类型
					let num = Number(val)
					if (num < 0) {
						this.$set(this.creatObj, "initializeEquipmentNum", 0)
					}
					if (num > 50) {
						this.$set(this.creatObj, "initializeEquipmentNum", 200)
					}
				}

			},
			// changeEnd
			selectParamConfigByCode() {
				this.$api.selectParamConfigByCode({
					"paramCode": 1002,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						for (let k of res.obj.paramConfigItemList) {
							this.restaurants.push({
								value: k.paramConfigItemName,
								id: k.paramConfigItemId
							})
						}

					}
				})
				this.$api.selectParamConfigByCode({
					"paramCode": 1005,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "luList", res.obj.paramConfigItemList)
					}
				})
				this.$api.selectParamConfigByCode({
					"paramCode": 1006,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "prefixList", res.obj.paramConfigItemList)
					}
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 5000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n) {
				this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					this.$set(this.searchObj, "communityId", item.communityId)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}


			},
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (restaurant) => {
					return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
				};
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			exportData() {
				this.openDia(5)
			},
			//现有设备二维码导出
			exportDatas() {
				this.$api.exportExistEquipmentExcel({
					
				}).then((res) => {
					console.log(res);
					// if (res.returnCode == 200) {
						// that.visibleShow = false
						// that.getData()
						const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
						const url = URL.createObjectURL(blob)
						const link = document.createElement('a')
						link.href = url
						link.download = 'Excel测试'
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)

					// }
				})
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm3") {
							that.addCommunityEquipment()
						} else if (formName == "ruleForm4") {
							that.$api.initializeCommunityEquipment({
								initializeEquipmentNum: that.creatObj.initializeEquipmentNum || 1,
								equipmentJackNumber: that.creatObj.equipmentJackNumber,
								prefix: that.creatObj.prefix
							}, "设备二维码", "zip").then((res) => {
								if (res.returnCode == 200) {
									that.visibleShow = false
									that.getData()
								}
							})
						} else if (formName == "ruleForm5") {
							if (Number(that.creatObj.equipmentMinPower) <= 0) {
								that.$message({
									type: 'warning',
									message: '请输入最小充电功率!'
								});
								return false
							}
							if (Number(that.creatObj.equipmentMaxPower) <= 0) {
								that.$message({
									type: 'warning',
									message: '请输入最大充电功率!'
								});
								return false
							}
							if (Number(that.creatObj.equipmentMinPower) >= Number(that.creatObj
								.equipmentMaxPower)) {
								that.$message({
									type: 'warning',
									message: '最小充电功率不能低于最大充电功率!'
								});
								return false
							}
							that.$set(that.creatObj, "equipmentMaxPower", (JSON.parse(JSON.stringify(that
								.creatObj)).equipmentMaxPower) * 10)
							that.$set(that.creatObj, "equipmentMinPower", (JSON.parse(JSON.stringify(that
								.creatObj)).equipmentMinPower) * 10)
							that.$api.updateCommunityEquipment(that.creatObj).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '充电功率配置成功!'
									});
									that.visibleShow1 = false
									that.$nextTick(() => {
										that.getData()
									})
								}
							})
						}

					} else {
						return false;
					}
				});

			},
			// 设备新增请求
			addCommunityEquipment() {
				let obj = {
					communityId: this.creatObj.communityId || "", //社区id
					communitySiteId: this.creatObj.communitySiteId || "", //站点id
					// communityEquipmentNo: this.creatObj.communityEquipmentNo || "", //设备硬件编号
					communityEquipmentName: this.creatObj.communityEquipmentName || "", //设备名称
					communityEquipmentIp: this.creatObj.communityEquipmentIp || "", //设备ip
					equipmentJackNumber: this.creatObj.equipmentJackNumber || "", //设备插座
					communitySiteName: this.creatObj.communitySiteName || "", //设备位置
					equipmentServiceProvider: this.creatObj.equipmentServiceProvider || "", //设备运营商
					equipmentStatus: this.creatObj.equipmentStatus || "", //设备状态 1正常 2故障 3掉线
					equipmentRunStatus: this.creatObj.equipmentRunStatus || "", //设备运营状态 1未投用 2运营中 3已拆除
					// equipmentInstallTime: this.creatObj.equipmentInstallTime || "" //安装时间
				}
				this.$api.addCommunityEquipment(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新建设备成功',
								type: 'success'
							});
							setTimeout(() => {
								// 刷新社区列表 和充电站   
								this.getData()
							}, 500)
						})
					}
				})
			},
			// 获取设备信息
			getselectCommunityEquipment(id, item) {
				console.log(item)
				this.$api.selectCommunityEquipment({
					communityEquipmentId: id
				}).then((res) => {
					console.log(res.obj)
					if (res.returnCode == 200) {
						this.$set(this, "creatObj", {
							communityEquipmentNo: res.obj.communityEquipmentNo,
							communityEquipmentName: res.obj.communityEquipmentName,
							communitySiteId: res.obj.communitySiteId,
							communityEquipmentIp: res.obj.communityEquipmentIp,
							equipmentJackNumber: res.obj.equipmentJackNumber,
							equipmentServiceName: res.obj.equipmentServiceProvider,
							equipmentServiceProvider: res.obj.equipmentServiceProviderId,
							equipmentRunStatus: res.obj.equipmentRunStatus,
							equipmentInstallTime: res.obj.equipmentInstallTime,
							communityEquipmentId: res.obj.communityEquipmentId,
							communityName: res.obj.communityName,
							communitySiteName: res.obj.communitySiteName,
							communityId: res.obj.communityId,
							equipmentStatus: res.obj.equipmentStatus,
							unlineTime: res.obj.unlineTime,
							unlineFlag: res.obj.unlineFlag,
							equipmentMinPower: item.equipmentMinPower / 10,
							equipmentMaxPower: item.equipmentMaxPower / 10,
							equipmentPortList: res.obj.equipmentPortList || [],
							equipmentInstallStatus: res.obj.equipmentInstallStatus || 1,
						})
						this.dialogVisible = true
						this.$nextTick(() => {
							this.$refs.ruleForm3.clearValidate()
						})
					}
				})
			},
			// 1编辑 5新增
			openDia(n, item) {
				if (n == 1) { //详情
					this.dialogTitle = "设备信息"
					this.getselectCommunityEquipment(item.communityEquipmentId, item)
				} else if (n == 5) { //新增
					this.visibleShow = true
					this.$nextTick(() => {
						this.$refs.ruleForm4.clearValidate()
					})
				}

			},
			createQRCode(n, item) {
				this.device = "设备二维码" + "    编号(" + item.communityEquipmentNo + ")"
				this.$api.createQRCode({
					communityEquipmentId: item.communityEquipmentId
				}).then((res) => {
					if (res) {
						// 1方式
						const myBlob = new window.Blob([res], {
							type: 'image/jpeg'
						})
						// 2方式
						const qrUrl = window.URL.createObjectURL(myBlob)
						this.$set(this, "cardUrl", qrUrl)
						this.equipmentCard = true
					}
				})

			},
			// 1编辑2运维记录3设备二维码4删除
			itemClick(item, n) {
				let that = this
				if (n == 1) {
					this.openDia(n, item)
				} else if (n == 2) {
					this.$emit("goUrl", item)
				} else if (n == 3) {
					this.createQRCode(n, item)

				} else if (n == 4) {
					this.$confirm('是否确认删除该设备?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									this.getData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 5) {
					this.$confirm('是否确认解绑设备（' + item.communityEquipmentName + '）?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.unbindCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '解绑成功!'
								});
								setTimeout(() => {
									this.getData({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 6) {
					this.$emit("goUrl", {
						communityEquipmentNo: item.communityEquipmentNo
					}, "/chargingManage")
				} else if (n == 7) {
					this.$confirm('是否确认复位设备（' + item.communityEquipmentName + '）?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.resetCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '复位成功!'
								});
								setTimeout(() => {
									this.getData({})
									this.rushData()
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 8) {
					console.log(item)
					this.$confirm('是否确认复位（' + item.communityEquipmentPort + '）号插口?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.resetCommunityEquipment({
							communityEquipmentId: item.communityEquipmentId,
							communityEquipmentPort: item.communityEquipmentPort
						}).then((res) => {
							console.log(res);
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '复位成功!'
								});
								setTimeout(() => {
									this.getselectCommunityEquipment(item.communityEquipmentId,
										item)
								}, 500)
							}
						})
					}).catch(() => {

					});
				} else if (n == 9) {
					this.visibleShow1 = true
					this.$set(this, "creatObj",item)
					this.$set(this.creatObj, "equipmentMaxPower", (JSON.parse(JSON.stringify(item)).equipmentMaxPower) /
						10)
					this.$set(this.creatObj, "equipmentMinPower", (JSON.parse(JSON.stringify(item)).equipmentMinPower) /
						10)
					this.$nextTick(() => {
						this.$refs.ruleForm5.clearValidate()
					})

				}
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData() {
				this.loading = true
				let obj = {
					communityId: this.searchObj.communityId, //社区编号
					communitySiteId: this.searchObj.communitySiteId,
					communityEquipmentNo: this.searchObj.communityEquipmentNo,
					equipmentStatus: this.searchObj.equipmentStatus,
					equipmentRunStatus: this.searchObj.equipmentRunStatus,
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
				}
				this.$api.listCommunityEquipment(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})

			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData()
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargingRecord.scss";
</style>